import 'leaflet/dist/leaflet.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import EventDetailPage from './pages/EventDetailPage';
import OrganizerPage from './pages/OrganizerPage';
import NotFoundPage from './pages/NotFoundPage';
import LandingPage from './pages/LandingPage';
import GlobalStyles from './styles/GlobalStyles';
import EventoCondiviso from './pages/EventoCondiviso';
import { initGA, trackPageView } from './utils/analytics';
import Privacy from './pages/Privacy';

// Componente per tracciare le pagine
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return null;
}

// Componente per la pagina admin
function AdminPage() {
  const goToAdmin = () => {
    console.log('Tentativo di andare ad admin...');
    window.open('/admin/', '_blank');
    
    setTimeout(() => {
      window.location.href = '/admin/';
    }, 1000);
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      fontSize: '18px',
      padding: '20px'
    }}>
      <h1>Accesso Admin Dashboard</h1>
      <p>Clicca uno dei pulsanti qui sotto:</p>
      
      <button 
        onClick={goToAdmin}
        style={{ 
          backgroundColor: '#007bff', 
          color: 'white', 
          padding: '15px 30px', 
          border: 'none',
          borderRadius: '5px',
          fontSize: '16px',
          cursor: 'pointer',
          marginTop: '20px',
          marginBottom: '10px'
        }}
      >
        Vai alla Dashboard Admin
      </button>
      
      <a 
        href="/admin/" 
        target="_blank"
        rel="noopener noreferrer"
        style={{ 
          backgroundColor: '#28a745', 
          color: 'white', 
          padding: '15px 30px', 
          textDecoration: 'none',
          borderRadius: '5px',
          fontSize: '16px',
          display: 'inline-block',
          marginBottom: '10px'
        }}
      >
        Link Diretto Admin
      </a>
      
      <p style={{ fontSize: '14px', color: '#666' }}>
        Se nessuno dei due funziona, prova manualmente:
        <br />
        <code>https://finday-app-b2a8o.ondigitalocean.app/admin/</code>
      </p>
      
      <div style={{ marginTop: '20px', fontSize: '12px', color: '#999' }}>
        <p>URL attuale: {window.location.href}</p>
        <p>Origin: {window.location.origin}</p>
      </div>
    </div>
  );
}

function App() {
  // ❌ RIMUOVI QUESTO BLOCCO:
  // useEffect(() => {
  //   if (window.location.hostname === 'www.finday.it') {
  //     window.location.replace('https://finday.it' + window.location.pathname + window.location.search);
  //   }
  // }, []);

  // Inizializza Google Analytics
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      initGA();
    }
  }, []);

  return (
    <>
      <GlobalStyles />
      <Router>
        <PageTracker />
        <Routes>
          {/* ✅ MANTIENI QUESTI - sono utili per vecchi link */}
          <Route path="/index" element={<Navigate to="/" replace />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/index.php" element={<Navigate to="/" replace />} />
          
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<HomePage />} />
          <Route path="/event/:id" element={<EventDetailPage />} />
          <Route path="/evento/:id" element={<EventoCondiviso />} />
          <Route path="/organizzatore/:organizerId" element={<OrganizerPage />} />
          <Route path="/organizzatore/search" element={<OrganizerPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
